export enum PaymentStatusTypes {
  success = 'Complete',
  cancel = 'Cancelled',
  failure = 'failure',
  pending = 'pending',
  error = 'error',
}
